// @ts-check
import { useQuery } from "react-query";
import { useOrganization } from "../OrganizationContext";
import { useApi } from "../shared/useApi";

export const USER = "user";

export const useUserQuery = (searchParams = {}) => {
  const api = useApi();
  const { selectedOrganization } = useOrganization();
  return useQuery([USER, selectedOrganization, searchParams], async () => {
    const response = await api.get(`v1/users`);
    const list = await response.json();
    return {
      list,
    };
  });
};
